module.exports = __webpack_public_path__ + "img/buy-sell.61e95514.png";